import { useFlag } from '@calendly/feature-check-react'
import styled from 'astroturf/react'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import _StyledWrapper from "wrapper-StyledWrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/wrapper.js?styleId=StyledWrapper";


const topSpace = 66
const bottomSpace = 30
const panelHeight = 700
const heightBreakpoint = topSpace + bottomSpace + panelHeight

const StyledWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "StyledWrapper",
  styles: _StyledWrapper,
  attrs: props => ({
    ...props,
    'data-booking-page-wrapper': true
  })
})

const Wrapper = ({ children, ...props }) => {
  const isPhone = useDeviceType('isPhone')
  const isTabletUp = useDeviceType('isTabletUp')
  const isDesktopUp = useDeviceType('isDesktopUp')
  const bookingAppRedesign = useFlag('booking_app_redesign', false)

  return (
    <StyledWrapper
      media-phone={isPhone}
      media-tablet-up={isTabletUp}
      media-desktop-up={isDesktopUp}
      bookingAppRedesign={bookingAppRedesign}
      {...props}
    >
      {children}
    </StyledWrapper>
  )
}

export default Wrapper
